const fragranceStyle = ({ isSmall, enableSmallView }) => `
    <style>

        ::-webkit-scrollbar-track {
            background-color: transparent;
        }

        ::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.3);
            border-radius: 5px;
        }
        .container {
            display: flex;
            flex-direction: column;
            width: 100%;
            justify-content: center;
            align-items: center;
            padding-bottom: 0px;
            padding-top: 100px;
            position: relative;
            z-index: 2;
        }
        .card-container {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: ${isSmall || enableSmallView ? '40px' : '10px'} ;
            align-items: center;
            justify-content: center;
        }

        .card-container::-webkit-scrollbar-track {
            background-color: transparent;
        }
        .card-container:hover {
            overflow-x: auto;
        }
        .card {
            width: ${isSmall || enableSmallView ? '90px' : '138px'};
            height: ${isSmall || enableSmallView ? '135px' : '182px'} ;
            background-color: #FCFAF5;
            border-radius: 11px;
            border: 1px solid #E6E8E8;
            flex-shrink: 0;
        }
        .card-image {
            width: 100%;
            height: ${isSmall || enableSmallView ? '90px' : '76%'} ;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: bottom;
            border-radius: 11px 11px 0px 0px;

        }
        .card-image-description {
            font-size: ${isSmall || enableSmallView ? '12px' : '14px'} ;
            line-height: 20px;
            letter-spacing: 0.28px;
            text-align: center;
            padding-top: 11px;
            padding-bottom: 11px;
            background-color: #FCFAF5;
            border-radius: 0px 0px 11px 11px
        }
        .description {
            margin-top: 10px;
        }
    </style>
  `;

export default fragranceStyle;
